import { Box } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@/components/base/app/AppBar";
import DrawerWrapper from "@/components/base/app/DrawerWrapper";
import DrawerItemList from "@/components/base/app/DrawerItemList";

import { useState } from "react";
import MainWrapper from "@/components/base/app/MainWrapper";

const drawerWidth = 240;

export default function AppDrawerWrapper({ children, title }) {
    const [mobileOpen, setMobileOpen] = useState(false);
    const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

    return (
        <>
            <Box
                sx={{
                    position: "relative",
                    display: { xs: "block", sm: "flex" },
                }}
            >
                <CssBaseline />

                <AppBar
                    title={title}
                    drawerWidth={drawerWidth}
                    handleDrawerToggle={handleDrawerToggle}
                />

                <DrawerWrapper
                    mobileOpen={mobileOpen}
                    drawerWidth={drawerWidth}
                    handleDrawerToggle={handleDrawerToggle}
                >
                    <DrawerItemList
                        handleItemClick={() => handleDrawerToggle()}
                    />
                </DrawerWrapper>

                <MainWrapper drawerWidth={drawerWidth}>{children}</MainWrapper>
            </Box>
        </>
    );
}
